import {
	DatePicker as AntdDatePicker,
	type DatePickerProps as AntdDatePickerProps,
} from "antd"
import type { Dayjs } from "dayjs"
import { AriaRole, cloneElement, isValidElement } from "react"
import { DATE_TIME_FORMAT } from "utils/date"

type DatePickerProps<
	ValueType = Dayjs,
	IsMultiple extends boolean = false,
> = AntdDatePickerProps<ValueType, IsMultiple>

export type { RangePickerProps } from "antd/es/date-picker"

export const DatePicker = Object.assign(Default, {
	DateTime,
	Month,
	RangePicker: AntdDatePicker.RangePicker,
})

function Default(props: DatePickerProps) {
	return (
		<AntdDatePicker
			{...props}
			panelRender={(originalPanel) => {
				if (
					!isValidElement<{ role: AriaRole; "aria-label": string }>(
						originalPanel,
					)
				) {
					return originalPanel
				}
				return cloneElement(originalPanel, {
					role: "dialog",
					"aria-label": props["aria-label"],
				})
			}}
		/>
	)
}

function DateTime({
	needConfirm = false,
	format = DATE_TIME_FORMAT,
	...props
}: DatePickerProps) {
	return (
		<Default
			{...props}
			showTime
			use12Hours
			needConfirm={needConfirm}
			format={format}
		/>
	)
}

function Month(props: DatePickerProps) {
	return (
		<Default
			{...props}
			picker="month"
			mode="month"
			format="YYYY MMMM"
			allowClear={false}
		/>
	)
}
